import React from 'react'
import './index.css'


const ReportBody = ({title}) => {
  return (
    <div className='report__body'>
      <p className='report__body-text'>{title}</p>
    </div>
  )
}


export  default  ReportBody
